import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import RequestBaseData from "./RequestBaseData";
import axios from "axios";

var ContactChange =
/*#__PURE__*/
function (_RequestBaseData) {
  _inherits(ContactChange, _RequestBaseData);

  function ContactChange() {
    _classCallCheck(this, ContactChange);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContactChange).call(this, "ContactChange"));
  }

  _createClass(ContactChange, [{
    key: "GetByRequestId",
    value: function () {
      var _GetByRequestId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(requestId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByRequestId/").concat(requestId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByRequestId(_x) {
        return _GetByRequestId.apply(this, arguments);
      }

      return GetByRequestId;
    }()
  }]);

  return ContactChange;
}(RequestBaseData);

export default new ContactChange();